<div class="single-page-validation" fxLayout>

  <ng-container *ngIf="pageIsValid(pageSlug, submitResult)">
    <div class="result-icon" fxFlex="nogrow">
        <mat-icon *ngIf="pageIsValid(pageSlug, submitResult)" class="result-icon">thumb_up</mat-icon>
    </div>
    <div class="page-name-wrapper" fxFlex>
      <span>{{ getPageName(pageName) }}</span>
    </div>
  </ng-container>
  
  <ng-container *ngIf="!pageIsValid(pageSlug, submitResult)">
    <div class="result-icon invalid">
        <mat-icon class="">thumb_down</mat-icon>
    </div>
    <div class="page-name-wrapper" fxFlex>
      <a [routerLink]="pageLink" [queryParams]="queryParams">
        {{ getPageName(pageName) }}
      </a>
    </div>
  </ng-container>

</div>
